import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { ENTRY_RENDER_TYPE } from 'site-modules/editorial/constants/best';
import { ResearchEntry } from 'site-modules/editorial/components/best/research-entry/research-entry';
import { AnchorNavSticky } from 'site-modules/shared/components/anchor-nav-sticky/anchor-nav-sticky';

export function MainContentUI({
  entries,
  onSelectCar,
  selectedCars,
  entriesProps,
  anchorNavTitle = undefined,
  anchorNavList = undefined,
  isMobile = false,
}) {
  const firstCardIndex = useMemo(
    () => entries.findIndex(entry => entry.metadata('renderType').value() === ENTRY_RENDER_TYPE.CARD),
    [entries]
  );

  return (
    <Fragment>
      {entries.map((entry, index) => {
        const key = `main-${entry.id}-${index}`;
        const isFirstCard = index === firstCardIndex;
        return (
          <Fragment key={key}>
            {isFirstCard && (
              <AnchorNavSticky
                className="mb-1_5"
                isMobile={isMobile}
                title={anchorNavTitle}
                navList={anchorNavList}
                containerClassName={null}
                hasSeparator={!!anchorNavList?.length}
                linkTrackingId="best_subnav_view_content"
              />
            )}
            <ResearchEntry
              key={key}
              entry={entry}
              onSelectCar={onSelectCar}
              selectedCars={selectedCars}
              isMobile={isMobile}
              entriesProps={{ ...entriesProps, entryPath: ['main'] }}
              hasSeparator
            />
          </Fragment>
        );
      })}
    </Fragment>
  );
}

MainContentUI.propTypes = {
  entries: PropTypes.arrayOf(CmsEntities.Content).isRequired,
  onSelectCar: PropTypes.func.isRequired,
  selectedCars: PropTypes.arrayOf(PropTypes.object).isRequired,
  entriesProps: PropTypes.shape({
    title: PropTypes.string,
    canonical: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  anchorNavTitle: PropTypes.string,
  anchorNavList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      hash: PropTypes.string,
    })
  ),
  isMobile: PropTypes.bool,
};

export const MainContent = React.memo(MainContentUI);
